"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ua_parser_js_1 = require("ua-parser-js");
const accept_language_parser_1 = __importDefault(require("accept-language-parser"));
const route_1 = __importStar(require("./route/route"));
const lookup_1 = require("./geoip/lookup");
const locale_1 = require("./locale");
const urls_1 = require("./url/urls");
const cookie_1 = require("./cookie");
const urlParamsTargeting_1 = require("./urlParamsTargeting");
const country_1 = require("./mobileData/country");
/**
 * Generate our the meristem context, used for experiment targeting purposes and for passing important information to the buyflow-client
 */
function getMeristemContext({ url, userAgent, geoip, apiDomain, wordpressDomain, cookies, acceptLanguage, }) {
    var _a, _b;
    const route = route_1.default(url, cookies);
    const redirect = urls_1.getRedirect(url, route, apiDomain, wordpressDomain, (_a = geoip === null || geoip === void 0 ? void 0 : geoip.country) === null || _a === void 0 ? void 0 : _a.iso_code);
    if (redirect) {
        return redirect;
    }
    const urlTargetingParams = urlParamsTargeting_1.getUrlTargetingParams(url);
    // User Locale //
    const geoLocation = lookup_1.getGeoIPDetails(geoip, url);
    const preferred_country_code = getPreferredCountry(geoLocation, acceptLanguage);
    const language_code = locale_1.getLanguage(route, cookies, acceptLanguage, geoLocation);
    const app_country_code = country_1.getAppCountryCode(url);
    // Device attributes //
    const useragent = new ua_parser_js_1.UAParser(userAgent);
    const device = useragent.getDevice();
    const os = useragent.getOS();
    const deviceInfo = {
        device_is_mobile: Boolean(device.type),
        device_brand: device.vendor || '',
        device_family: device.type || '',
        device_os: os.name || '',
    };
    // Build Response //
    const setCookie = cookie_1.buildCookieDefinitions({
        language_code,
        // Falling back to _direct as an extra safety net
        route_id: ((_b = route === null || route === void 0 ? void 0 : route.context) === null || _b === void 0 ? void 0 : _b.route_id) || route_1.ROUTE_FALLBACK,
    });
    return {
        ...geoLocation,
        ...deviceInfo,
        ...urlTargetingParams,
        pathname: url.pathname,
        route,
        ...route === null || route === void 0 ? void 0 : route.context,
        language_code,
        preferred_country_code,
        setCookie,
        app_country_code,
    };
}
exports.default = getMeristemContext;
/**
 * Derives preferred country code based on Accept-Language header.
 * Example: "fr-CH, fr;q=0.9, en;q=0.8" Returns "CH"
 * Spec ref https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Accept-Language
 * This function will fallback to any overrides (i.e. from fcc query params)
 */
function getPreferredCountry(geoLocation, acceptLanguage) {
    var _a;
    if (!geoLocation.is_forced_country_code) {
        const locales = accept_language_parser_1.default.parse(acceptLanguage);
        const preferredCountry = (_a = locales[0]) === null || _a === void 0 ? void 0 : _a.region;
        if (preferredCountry) {
            return preferredCountry;
        }
    }
    return geoLocation.country_code;
}
//# sourceMappingURL=meristemContext.js.map